import React from 'react';

import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { PlaneIcon } from '@Generic/icons';
import { FEATURE_FLAG_ABSENCE_MANAGEMENT, FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN } from '@ApplicationWide/feature-flags';

const AdminAbsenceManagementPage = React.lazy(() =>
  import('../../../pages/Admin/AbsenceManagement/AdminAbsenceManagementPoliciesPage'),
);

export default {
  label: 'time-off.admin-page.title',
  group: ADMIN,
  to: '/administration/absence-management',
  route: '/administration/absence-management',
  component: AdminAbsenceManagementPage,
  icon: <PlaneIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_TIME_OFF,
  area: ADMIN_TIME_OFF,
  featureFlag: [FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN, FEATURE_FLAG_ABSENCE_MANAGEMENT],
  hasNavBar: true,
};
